import { action } from 'satcheljs';
import InboxPlusPivotViewState from 'owa-mail-inbox-plus-store/lib/store/schema/InboxPlusPivotViewState';
import { addDatapointConfig } from 'owa-analytics-actions';
import getUserConfigurationTabFromInboxClassificationFilter from 'owa-mail-inbox-plus-actions/lib/selectors/getUserConfigurationTabFromInboxClassificationFilter';

export const setShouldShowPivotEnableDisableDialog = action(
    'SET_IS_PIVOT_REORDER_DIALOG_SHOWN',
    (shouldShow: boolean) => ({
        shouldShow,
    })
);

export const pivotToggled = action(
    'PIVOT_TOGGLED',
    (pivot: InboxPlusPivotViewState, shouldEnable: boolean) =>
        addDatapointConfig(
            {
                name: shouldEnable ? 'TnS_InboxPlusPivotEnabled' : 'TnS_InboxPlusPivotDisabled',
                customData: {
                    pivot: getUserConfigurationTabFromInboxClassificationFilter(
                        pivot.InboxClassificationFilter
                    ),
                },
            },
            {
                pivot,
                shouldEnable,
            }
        )
);

export const focusedOtherPivotsToggled = action(
    'FOCUSED_OTHER_PIVOTS_TOGGLED',
    (shouldEnableFocusedOther: boolean) =>
        addDatapointConfig(
            {
                name: shouldEnableFocusedOther
                    ? 'TnS_InboxPlusPivotEnabled'
                    : 'TnS_InboxPlusPivotDisabled',
                customData: { pivot: 'Focused/Other' },
            },
            { shouldEnableFocusedOther }
        )
);
